
define('text!views/user/register/financial/visaredirect.html',[],function () { return '<div class="spinner" />\r\n<p>We are now redirecting you to Visa\'s secure site to link your card</p>';});

